<template>
  <div class="space-y-6">
    <div v-for="weekNum in weekCount" :key="weekNum" class="border border-gray-200 rounded-lg overflow-hidden bg-white">
      <!-- Week header skeleton -->
      <div class="bg-gray-50 px-4 py-3 border-b border-gray-200">
        <div class="flex justify-between items-center">
          <div class="flex items-center gap-3">
            <div class="h-4 w-16 bg-gray-300 rounded animate-pulse" />
            <div class="h-4 w-20 bg-gray-200 rounded animate-pulse" />
          </div>
          <div class="flex items-center gap-2">
            <div class="h-3 w-12 bg-gray-200 rounded animate-pulse" />
            <div class="h-4 w-8 bg-cosmicPurple/20 rounded animate-pulse" />
          </div>
        </div>
      </div>

      <!-- Table skeleton -->
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-white">
          <tr>
            <th class="w-10 py-3 px-2">
              <div class="h-4 w-4 bg-gray-200 rounded animate-pulse mx-auto" />
            </th>
            <th class="w-8 py-3">
              <div class="h-4 w-4 bg-gray-200 rounded animate-pulse mx-auto" />
            </th>
            <th class="w-14 py-3">
              <div class="h-4 w-10 bg-gray-200 rounded animate-pulse mx-auto" />
            </th>
            <th class="py-3 pl-2">
              <div class="h-4 w-12 bg-gray-200 rounded animate-pulse" />
            </th>
            <th class="w-16 py-3">
              <div class="h-4 w-12 bg-gray-200 rounded animate-pulse mx-auto" />
            </th>
            <th class="w-16 py-3">
              <div class="h-4 w-10 bg-gray-200 rounded animate-pulse mx-auto" />
            </th>
            <th class="w-16 py-3">
              <div class="h-4 w-14 bg-gray-200 rounded animate-pulse mx-auto" />
            </th>
            <th class="w-16 py-3">
              <div class="h-4 w-14 bg-gray-200 rounded animate-pulse mx-auto" />
            </th>
            <th class="w-16 py-3">
              <div class="h-4 w-8 bg-gray-200 rounded animate-pulse mx-auto" />
            </th>
            <th class="w-16 py-3">
              <div class="h-4 w-10 bg-gray-200 rounded animate-pulse mx-auto" />
            </th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr v-for="rowNum in getRowCount(weekNum)" :key="rowNum">
            <td class="py-4 px-2">
              <div class="h-4 w-4 bg-gray-100 rounded animate-pulse mx-auto" />
            </td>
            <td class="py-4">
              <div class="h-4 w-6 bg-gray-100 rounded animate-pulse mx-auto" />
            </td>
            <td class="py-4">
              <div class="h-5 w-5 bg-gray-100 rounded animate-pulse mx-auto" />
            </td>
            <td class="py-4 pl-2">
              <div class="h-4 bg-gray-100 rounded animate-pulse" :style="{ width: `${120 + rowNum * 30}px` }" />
            </td>
            <td class="py-4">
              <div class="h-4 w-10 bg-gray-100 rounded animate-pulse mx-auto" />
            </td>
            <td class="py-4">
              <div class="h-4 w-6 bg-gray-100 rounded animate-pulse mx-auto" />
            </td>
            <td class="py-4">
              <div class="h-4 w-4 bg-gray-100 rounded animate-pulse mx-auto" />
            </td>
            <td class="py-4">
              <div class="h-4 w-4 bg-gray-100 rounded animate-pulse mx-auto" />
            </td>
            <td class="py-4">
              <div class="h-7 w-7 bg-blue-50 rounded animate-pulse mx-auto" />
            </td>
            <td class="py-4">
              <div class="h-7 w-7 bg-red-50 rounded animate-pulse mx-auto" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  weekCount?: number
}>()

const getRowCount = (weekNum: number) => {
  // Vary row counts for visual interest: 4, 3, 2 rows
  return Math.max(2, 5 - weekNum)
}
</script>

